import { useMemo } from 'react';
import type { Task } from '@shared/types';
import { useDb } from '@/lib/store';

/** Previous / next task among siblings (same list and parent), in manual order. */
export function useTaskSiblings(task: Task | undefined) {
  const tasks = useDb((db) => db.tasks);
  return useMemo(() => {
    if (!task) return { prev: undefined, next: undefined };
    const sibs = Object.values(tasks)
      .filter((t) => t.listId === task.listId && (t.parentId ?? null) === (task.parentId ?? null) && !t.archived)
      .sort((a, b) => a.orderIndex - b.orderIndex);
    const i = sibs.findIndex((t) => t.id === task.id);
    return { prev: i > 0 ? sibs[i - 1] : undefined, next: i >= 0 && i < sibs.length - 1 ? sibs[i + 1] : undefined };
  }, [tasks, task]);
}
